import { Box, Typography } from '@mui/material'
import React from 'react'

function SettingsRow({ title, data }: { title: string; data: any }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: '300',
        }}
      >
        {title}
      </Typography>
      <Box>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '400',
            paddingLeft: '20px',
            paddingY: '10px',
          }}
        >
          {data}
        </Typography>
      </Box>
    </Box>
  )
}

export default SettingsRow
